import Vue from 'vue';
import Router from 'vue-router';

import Login from '../components/Login'
import Register from '../components/Register'
import Profile from "../components/Profile";
import Home from "../components/Home";
import Events from "../components/Events";
import Friend from "../components/Friends";
import Dashboard from "../components/Dashboard";
import FieldDetail from "../components/FieldDetail";
import Main from "../components/Main";
import CreateEvent from "../components/CreateEvent";
import Messages from "../components/Messages";
import FieldOverview from "../components/FieldOverview";
import CreateField from "../components/CreateField";

Vue.use(Router);

export const router = new Router({
    routes: [
        {path: '/', component: Main},
        {path: '/login', component: Login},
        {path: '/login/:codeStatus', component: Login},
        {path: '/register', component: Register},
        {
            path: '/home', component: Home,
            children: [
                {path: '/', redirect: '/home/dashboard'},
                {path: '/home/dashboard', component: Dashboard},
                {path: '/home/fields/create', component: CreateField},
                {path: '/home/fields/', component: FieldOverview},
                {path: '/home/events/create', component: CreateEvent},
                {path: '/home/events/:id', component: Events},
                {path: '/home/fields/:id', component: FieldDetail},
                {path: '/home/profile', component: Profile},
                {path: '/home/friends', component: Friend},
                {path: '/home/messages', component: Messages},
                {path: '*', redirect: '/home/dashboard'}

            ]
        },
        // otherwise redirect to home
        {path: '*', redirect: '/'}
    ]
});

router.beforeEach((to, from, next) => {
    // redirect to login page if not logged in and trying to access a restricted page
    const publicPages = ['/','/login','/login/success','/login/codeused','/login/invalid', '/login/exception', '/register'];
    const authRequired = !publicPages.includes(to.path);
    const loggedIn = localStorage.getItem('token');

    if (authRequired && !loggedIn) {
        return next('/login');
    }

    next();
});
